import React from 'react'

const Colors = () => {
  return (
    <div>
      this is my color
    </div>
  )
}

export default Colors
